import type { FloatingSide } from './FloatingPlacement';

export type TriggerRect = Pick<DOMRect, 'top' | 'bottom' | 'left' | 'right'>;

export type Viewport = {
  width: number;
  height: number;
};

const SIDES_BY_PRIORITY: FloatingSide[] = ['top', 'bottom', 'right', 'left'];

const resolveAutoSide = (triggerRect: TriggerRect, viewport: Viewport): FloatingSide => {
  const freeSpaceBySide: Record<FloatingSide, number> = {
    top: triggerRect.top,
    bottom: viewport.height - triggerRect.bottom,
    left: triggerRect.left,
    right: viewport.width - triggerRect.right,
  };

  return SIDES_BY_PRIORITY.reduce((bestSide, side) =>
    freeSpaceBySide[side] > freeSpaceBySide[bestSide] ? side : bestSide
  );
};

export default resolveAutoSide;
